var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu01On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_8191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6736 19.8987H0.330267C0.150821 19.8987 0.00366211 19.7516 0.00366211 19.5722V2.42424C0.00366211 2.24479 0.150821 2.09766 0.330267 2.09766H21.6736C21.8531 2.09766 22.0002 2.24479 22.0002 2.42424V19.5722C22.0002 19.7516 21.8531 19.8987 21.6736 19.8987ZM0.656872 19.2456H21.3471V2.75084H0.656872V19.2456Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6699 6.06701H0.326561C0.147115 6.06701 0 5.91986 0 5.74041V2.42424C0 2.24479 0.147115 2.09766 0.326561 2.09766H21.6699C21.8494 2.09766 21.9965 2.24479 21.9965 2.42424V5.74041C21.9965 5.91986 21.8494 6.06701 21.6699 6.06701ZM0.653166 5.41383H21.3434V2.75084H0.653166V5.41383Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98146 4.40937C1.89523 4.40937 1.81259 4.37344 1.75151 4.31236C1.69043 4.25128 1.65454 4.16864 1.65454 4.08241C1.65454 3.99618 1.69043 3.91357 1.75151 3.85249C1.82696 3.77704 1.94196 3.7447 2.04615 3.76267C2.06771 3.76626 2.08928 3.77344 2.10724 3.78063C2.1288 3.78781 2.14673 3.79857 2.1647 3.80935C2.18266 3.82372 2.20063 3.83452 2.215 3.84889C2.27608 3.90997 2.31201 3.99618 2.31201 4.07882C2.31201 4.16145 2.27608 4.24768 2.215 4.30876C2.15392 4.36984 2.07128 4.40578 1.98505 4.40578L1.98146 4.40937Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61572 4.41024C4.52949 4.41024 4.44685 4.37431 4.38578 4.31323C4.35703 4.28448 4.33186 4.24856 4.31749 4.20545C4.29952 4.16592 4.29236 4.12639 4.29236 4.08328C4.29236 3.99705 4.32829 3.91443 4.38937 3.85335C4.40374 3.83898 4.42171 3.8246 4.43968 3.81382C4.45764 3.80304 4.47557 3.79228 4.49713 3.78509C4.5151 3.7779 4.53667 3.7707 4.55823 3.76711C4.60134 3.75992 4.64445 3.75992 4.68756 3.76711C4.70553 3.7707 4.73069 3.7779 4.74866 3.78509C4.76662 3.79228 4.78815 3.80304 4.80611 3.81382C4.82407 3.82819 4.84204 3.83898 4.85282 3.85335C4.9139 3.91443 4.94983 4.00064 4.94983 4.08328C4.94983 4.12639 4.94267 4.16952 4.9247 4.20545C4.90674 4.24856 4.88156 4.28089 4.85282 4.31323C4.79174 4.37431 4.7091 4.41024 4.62287 4.41024H4.61572Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29852 4.4097C3.21229 4.4097 3.12965 4.37377 3.06857 4.31269C3.00749 4.25161 2.97156 4.16897 2.97156 4.08274C2.97156 3.99652 3.00749 3.9139 3.06857 3.85282C3.08294 3.83845 3.10091 3.82406 3.11888 3.81328C3.13684 3.8025 3.15482 3.79174 3.17637 3.78455C3.19434 3.77737 3.21587 3.77017 3.23742 3.76657C3.34521 3.74861 3.45661 3.78094 3.53206 3.85639C3.59314 3.91747 3.62908 4.0037 3.62908 4.08634C3.62908 4.16898 3.59673 4.25521 3.53206 4.31629C3.47098 4.37737 3.38834 4.4133 3.30211 4.4133L3.29852 4.4097Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3983 8.83285H2.96792C2.78847 8.83285 2.64136 8.68572 2.64136 8.50627C2.64136 8.32682 2.78847 8.17969 2.96792 8.17969H11.3983C11.5778 8.17969 11.7249 8.32682 11.7249 8.50627C11.7249 8.68572 11.5778 8.83285 11.3983 8.83285Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8059 11.4696H2.96792C2.78847 11.4696 2.64136 11.3225 2.64136 11.143C2.64136 10.9636 2.78847 10.8164 2.96792 10.8164H18.8059C18.9853 10.8164 19.1325 10.9636 19.1325 11.143C19.1325 11.3225 18.9853 11.4696 18.8059 11.4696Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8059 14.1024H2.96792C2.78847 14.1024 2.64136 13.9552 2.64136 13.7758C2.64136 13.5964 2.78847 13.4492 2.96792 13.4492H18.8059C18.9853 13.4492 19.1325 13.5964 19.1325 13.7758C19.1325 13.9552 18.9853 14.1024 18.8059 14.1024Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.806 16.7352H8.23664C8.05719 16.7352 7.91003 16.5881 7.91003 16.4086C7.91003 16.2292 8.05719 16.082 8.23664 16.082H18.806C18.9855 16.082 19.1326 16.2292 19.1326 16.4086C19.1326 16.5881 18.9855 16.7352 18.806 16.7352Z",
    fill: "#5F9E87",
    stroke: "#5F9E87",
    strokeWidth: 0.285423
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_8191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu01On);
export default __webpack_public_path__ + "static/media/icon-menu-01-on.7a308939e1c9768136ad2d7b107fded7.svg";
export { ForwardRef as ReactComponent };